import { create } from 'zustand';

interface SearchConditionState {
  // 화면 검색조건
  searchFilters: any;
  setSearchFilters: (condition: any) => void;
}

export const useSearchFilterStore = create<SearchConditionState>((set) => ({
  searchFilters: {},
  setSearchFilters: (searchFilters) => set({ searchFilters }),
}));
